
import angular from 'angular';
import { AncillariesUtilsService } from '../../../../shared/ib-web-ancillaries-utils';

const controllerInfo = {
    module: 'ib-ancillaries-modal-module',
    inject: ['$uibModalInstance', 'ModalServiceAncillaries', '$anchorScroll', '$location', '$route', 'ErrorModel', 'AncillariesConstants'],
    required: []
};

export class GenericErrorModalAncillariesController implements ng.IController {

    public model;
    constructor (
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private ModalServiceAncillaries: any,
        private $anchorScroll: any,
        private $location: any,
        private $route: any,
        private ErrorModel: any,
        private AncillariesConstants: AncillariesConstant) {
        this.model = ErrorModel;
    }



    accept = (): void => {
        if (this.errorsCode() === 'IB_00002' || this.errorGetOut() === true) {
            this.$location.path(this.AncillariesConstants.PAGES_ROUTES.SEARCH_BOOKING);
        }
        this.$uibModalInstance.close();
    };

    errorMessage = (): any => {
        return this.ModalServiceAncillaries.getErrorMessage();
    };

    errorPassenger = (): any => {
        return this.ModalServiceAncillaries.getErrorPassenger();
    };

    errorsCode = (): any => {
        return this.ModalServiceAncillaries.getErrorCode();
    };

    errorGetOut = (): any => {
        return this.ModalServiceAncillaries.getErrorGetOut();
    };

    acceptBoardingCards = (): void => {
        this.$location.path(this.AncillariesConstants.PAGES_ROUTES.CONFIRMATION_PAGE);
        close();
    };

    acceptSeatsMapErrror = (): void => {
        this.$location.path(this.AncillariesConstants.PAGES_ROUTES.ANCILLARIES_PAGE);
        close();
    };


    closePendingPayments = (): void => {
        this.$uibModalInstance.close(null);
    };

    acceptPendingAqqError = (): void => {
        this.$route.reload();
        close();
    };
    apisUncheckableError = (): void => {
        this.$location.path(this.AncillariesConstants.PAGES_ROUTES.FLIGHTS_AND_PASSENGERS);
        close();
    };

    close = (): void => {
        if (this.errorsCode() === 'IB_00002' || this.errorGetOut() === true) {
            this.$location.path(this.AncillariesConstants.PAGES_ROUTES.SEARCH_BOOKING);
        }
        this.ModalServiceAncillaries.setErrorCode('');
        this.$uibModalInstance.dismiss('cancel');
    };
    changeToTrue = (): void => {
        this.$uibModalInstance.close('cancel');
    };

    gotoAnchor = (x): void => {
        const newHash = x;
        if (this.$location.hash() !== newHash) {
            this.$location.hash(x);
        } else {
            this.$anchorScroll();
        }
    };

}


try {
    GenericErrorModalAncillariesController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(GenericErrorModalAncillariesController.name, GenericErrorModalAncillariesController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    GenericErrorModalAncillariesController.$inject = controllerInfo.inject;
    mod.controller(GenericErrorModalAncillariesController.name, GenericErrorModalAncillariesController);
}